import { HttpHeaders } from "@angular/common/http";

export function getFilenameFromHeaders(headers: HttpHeaders, fallbackName: string): string {
    const contentDisposition = headers.get('Content-Disposition');
    if (contentDisposition) {
        // Extract the first filename value (handles both quoted and unquoted)
        const filenameMatch = /filename=([^;]+)/.exec(contentDisposition);
        if (filenameMatch && filenameMatch[1]) {
            // Remove quotes if present and trim whitespace
            return filenameMatch[1].replace(/^["']|["']$/g, '').trim();
        }
    }
    return fallbackName;
}